<template>
  <div class="container">
    <el-button class="button" type="info" @click="doPre">{{leftWord}}</el-button>
    <el-button class="button" type="success" @click="doNext">{{rightWord}}</el-button>
  </div>
</template>
<script>
export default {
  props: {
    leftWord: {
      type: String,
      default: "上一步",
    },
    rightWord: {
      type: String,
      default: "下一步",
    },
  },
  methods: {
    doPre() {
      switch (this.leftWord) {
        case "保存草稿箱":
          this.keep();
          break;
        default:
          this.$emit("childrenDoPre");
          break;
      }
    },
    doNext() {
      console.log(111);
      this.$emit("childrenDoNext");
    },
    // 没用上
    keep() {
      // console.log("保存草稿箱");
      // alert("保存草稿箱");
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  align-content: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 30px;
}
.button {
  width: 30%;
}
</style>
